/**
 * `http`请求超时毫秒数
 * 1. 20秒
 */
export const HttpRequestTimeoutMs = 20000;

/**
 * 接口出错默认提示语
 */
export const ApiHasErrorMessage = '服务繁忙，请稍后重试！';
